import React from 'react'
import {JSONFetcher, StateLabel, gaEvent, findApiV4Link} from 'shared'

export class Description extends React.Component {
  state = { projects: [], totalProjects: 0 }

  componentDidMount() {
    JSONFetcher.load({
      url: findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'featured_projects'}),
      success: response => this.setState({totalProjects: response.total_entries, projects: response.data})
    })
  }

  render() {
    const contact = this.props.fundraisingEvent.contact
    const contactPicture = findApiV4Link({ofObject: contact.picture, withRel: 'fill_100x100'})
    const newMessageUrl = findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'new_message'})

    const projects = this.state.projects.map((project, i) => <Project key={i} {...project} />)

    return <div className="fundraising-events-show-description has-generic-scroll-down-button" id="description">
      <div className="container">
        <div className="row">
          <div className="col-md-24">
            <h1 className="text-center font-lg">{I18n.t('fundraising_events.show.description.headline')}</h1>
          </div>
          <div className="col-md-16 left-column p-r font-big-text">
            <div className="trix-content"  dangerouslySetInnerHTML={{ __html: this.props.fundraisingEvent.description }} />

            <div className="creation-information">
              <img className="manager-image" src={contactPicture} width="100" height="100" />
              <p className="m-b-0">
                <strong dangerouslySetInnerHTML={{ __html: contact.name}}></strong> {
                  I18n.t('fundraising_events.show.description.creation_information_html', {created_at: I18n.l("date.formats.default", this.props.fundraisingEvent.created_at)})
                } <a href={newMessageUrl}>{I18n.t('fundraising_events.show.description.new_message_link')}</a>
              </p>
            </div>
          </div>

          <div className="col-md-8 right-column has-reloaded-content" style={{minHeight: 200}}>
            <div className="fundraising-events-projects-index">
              <h4 className="m-b">{I18n.t('fundraising_events.projects.index.headline', {count: this.state.totalProjects})}</h4>
              <div className="project-list">
                {projects}
              </div>
              <p style={{ fontSize: '14px'}}dangerouslySetInnerHTML={{ __html: I18n.t('fundraising_events.show.description.hint_html', { name: this.props.fundraisingEvent.contact.name }) }}></p>

            </div>
          </div>
        </div>
      </div>
      <a className="generic-scroll-down-button" onClick={(event) => {
        event.preventDefault()
        gaEvent('engagement', 'click down_arrow', 'from description to news')
        document.querySelector('#news').scrollIntoView({behavior: 'smooth'})
      }} href="#news" />
    </div>
  }
}

const Project = (props) => {
  const url = findApiV4Link({ofObject: props, withRel: 'platform'})
  const image = findApiV4Link({ofObject: props.carrier.picture, withRel: 'fill_100x100'})
  let state = props.completed_at ? 'completed' : (props.closed_at ? 'closed' : null)

  return <a href={url}>
    <div className="media m-b-sm">
      <div className="media-body">
        <p className="media-heading m-b-0">
          <StateLabel state={state} /> <span className="highlight-on-hover" dangerouslySetInnerHTML={{__html: props.title}} />
        </p>
      </div>
      <div className="media-right">
        <img className="media-object" src={image} width="70" height="70" />
      </div>
    </div>
  </a>
}
